var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShieldOffSolid = function SvgShieldOffSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.669 17.669A12 12 0 0 1 11.999 21 12 12 0 0 1 3.5 6c.798.036 1.59 0 2.367-.126l11.803 11.795ZM8.958 4.962A11.999 11.999 0 0 0 12 3a12 12 0 0 0 8.5 3 11.999 11.999 0 0 1-1.117 9.379",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m3 3 18 18m-3.331-3.331A12 12 0 0 1 11.999 21 12 12 0 0 1 3.5 6c.798.036 1.59 0 2.367-.126l11.803 11.795ZM8.958 4.962A11.999 11.999 0 0 0 12 3a12 12 0 0 0 8.5 3 11.999 11.999 0 0 1-1.117 9.379L8.958 4.962Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgShieldOffSolid;